import React from "react"
import { Link } from "react-router-dom"

export default function LandingPage() {
  const upcomingShows = [
    { date: "April 10", venue: "The Chapel on Chapel", ticketUrl: "https://square.link/u/3lbHfMrb" },
    { date: "May 13", venue: "The OV Arts Centre", ticketUrl: "https://square.link/u/8J0QlxmK"},
    { date: "June 19", venue: "The OV Arts Centre", ticketUrl: "https://square.link/u/qU7TJucv"},
  ]

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-white">
      <div className="text-center p-8">
        <img
          src="/phatask.png"
          alt="Phat Ask Logo"
          className="max-w-2xl w-full mb-8 mx-auto"
        />

        <div className="space-y-8">
          <div>
            <h2 className="text-3xl font-bold text-gray-800 mb-6">Upcoming Shows</h2>
            <div className="space-y-4">
              {upcomingShows.map((show, index) => (
                <div key={index} className="flex items-center justify-center gap-4 flex-wrap">
                  <span className="text-xl font-semibold text-gray-700">
                    {show.date} @ {show.venue}
                  </span>
                  {show.ticketUrl ? (
                    <a
                      href={show.ticketUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="inline-block bg-cyan-400 hover:bg-cyan-500 text-black font-bold text-lg px-8 py-3 rounded-lg transition-colors duration-200 shadow-lg hover:shadow-xl"
                    >
                      Get Tickets
                    </a>
                  ) : (
                    <span className="text-gray-500 italic">Link to purchase tickets coming soon</span>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
